import React, { useState, useEffect } from 'react';
import moment from 'moment';
import toast from 'react-hot-toast';
import { Grid } from '@mui/material';
import { postRequestHeaders } from '../../../utils';
import {
    Input,
    CommonModal,
    LoadingButtonV4,
    Select,
} from '../../Common';
import Routes from '../../../routes';
import { useIntl } from 'react-intl';
import useNavigate from '../../../hooks/useNavigate';

export const yes_no_options = [
    { id: false, label: "No" },
    { id: true, label: "Yes" },
];

const EditInstanceSSO = ({
    payload,
    modalOpen,
    onClose,
    history = {},
}) => {
    const intl = useIntl();
    const [id, setId] = useState('');
    const [instanceId, setInstanceId] = useState('');
    const [accountName, setAccountName] = useState('');
    const [redirectURL, setRedirectURL] = useState('');
    const [enabledOnDesktop, setEnabledOnDesktop] = useState('');
    const [enabledOnMobile, setEnabledOnMobile] = useState('');
    const [configurationDetails, setConfigurationDetails] = useState('');
    
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (payload != null) {
            setId(payload.id);
            setInstanceId(payload.instanceId);
            setAccountName(payload.accountName);
            setRedirectURL(payload.redirectURL);
            setEnabledOnDesktop(payload.enabledOnDesktop);
            setEnabledOnMobile(payload.enabledOnMobile);
            setConfigurationDetails(payload.configurationDetails);
        }
    }, [payload]);

    const resetState = () => {
        setId('');
        setInstanceId('');
        setAccountName('');
        setRedirectURL('');
        setEnabledOnDesktop('');
        setEnabledOnMobile('');
        setConfigurationDetails('');
        
        setErrors({});
        setLoading(false);
    };

    const closeModal = () => {
        resetState();
        onClose();
    };

    const validateFields = () => {
        const errorObject = {};
        setErrors(errorObject);
        let fieldsAreValid = true;

        //const selectedAsset = options.assets.find(a => a.id === assetId) || {};
        
        //if (!assetId) {
        //    errorObject.assetId = true;
        //    fieldsAreValid = false;
        //}
        
        setErrors(errorObject);
        return fieldsAreValid;
    };

    const submit = async () => {
        const fieldsAreValid = validateFields();

        if (!fieldsAreValid) {
            return null;
        }

        setLoading(true);


        const data =
        {
            id: id,
            instanceId: instanceId,
            accountName: accountName,
            redirectURL: redirectURL,
            enabledOnDesktop: enabledOnDesktop,
            enabledOnMobile: enabledOnMobile,
            configurationDetails: configurationDetails
        };

        const response = await fetch(Routes.InstanceSSO.EditInstanceSSO(), {
            method: "POST",
            headers: { ...postRequestHeaders },
            body: JSON.stringify(data)
        });

        const responseData = await response.json();
        
        if (response.status === 200) {
            toast.success('Instance SSO settings successfully updated.', { duration: 6000 });
            resetState();
            window.scrollTo(0, 0);
            return onClose();
        }
        setLoading(false);
        return toast.error('There was an error, Please try again.', { duration: 6000 });
    };
    
    return (
        <CommonModal
            open={modalOpen}
            close={closeModal}
            header="Edit SSO Configuration"
        >
            <Grid container spacing={2} justifyContent='center'>
                <Grid item xs={10} align='center'>
                    <Input 
                        disabled
                        fullWidth
                        label="Account Name"
                        value={accountName}
                    />
                </Grid>
                <Grid item xs={10} align='center'>
                    <Input
                        fullWidth
                        label="Redirect URL"
                        value={redirectURL}
                        error={errors.redirectURL}
                        onChange={e => setRedirectURL(e.target.value)}
                    />
                </Grid>
                <Grid item xs={10} align='center'>
                    <Select
                        value={enabledOnDesktop}
                        label="Enabled On Desktop?"
                        options={yes_no_options}
                        error={errors.enabledOnDesktop}
                        onChange={e => setEnabledOnDesktop(e.target.value)}
                    />
                </Grid>
                <Grid item xs={10} align='center'>
                    <Select
                        value={enabledOnMobile}
                        label="Enabled On Mobile?"
                        options={yes_no_options}
                        error={errors.enabledOnMobile}
                        onChange={e => setEnabledOnMobile(e.target.value)}
                    />
                </Grid>
                <Grid item xs={10} align='center'>
                    <Input
                        multiline
                        rows={5}
                        fullWidth
                        label="Configuration Details"
                        value={configurationDetails}
                        error={errors.configurationDetails}
                        onChange={e => setConfigurationDetails(e.target.value)}
                    />
                </Grid>
                <Grid item xs={8} mt={2} align='center'>
                    <LoadingButtonV4
                        useLargeButton
                        buttonText='Edit SSO Configuration'
                        onClick={submit}
                        loading={loading}
                    />
                </Grid>
            </Grid>
        </CommonModal>
    );
};

export default EditInstanceSSO;
